import React from 'react'
import useIsInViewport from 'use-is-in-viewport'

import Heading2 from '../../../elements/titles/Heading2'
import Paragraph from '../../../elements/p/Paragraph'
import ButtonHead from '../../../elements/buttons/ButtonHead'

const ErrorDescription = () => {

	const [isInViewport, targetRef] = useIsInViewport()

	return (
		<section
			ref={targetRef}
			className={`${ isInViewport ? "visibleDiv" : "hiddenDiv"} w-full h-screen flex flex-col items-center justify-center space-y-5 md:space-y-10 text-center p-3 md:px-5`} 
		>
			<Heading2>Cette page n'existe pas</Heading2>
			<Paragraph>La page que vous recherchez semble introuvable. veuillez retourner à page d'accueil</Paragraph>
			<ButtonHead link="/">Page d'accueil</ButtonHead>
		</section>
	)
}

export default ErrorDescription